import React, { useEffect, useMemo, useRef, useState } from "react";
import { FaCheck, FaEdit, FaTrash, FaPlus, FaPaperclip, FaEye } from "react-icons/fa";
import "./GastosPage.css";
import ActionMenu from "../../comunes/componentes/ActionMenu";
import {
  crearGasto,
  actualizarGasto,
  anularGasto,
  duplicarGasto,
  obtenerGastosPaginados,
  escucharGastosRecientes,
} from "../../firebase/gastos";
import { puedeHacer } from "../../utils/permisos";
import { fusionarDocumentosPaginados } from "../../utils/paginacionRealtime";
import { escucharProveedores } from "../../firebase/proveedores";
import { fechaHoyNegocio } from "../../utils/fechas";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase";

const categoriasBase = [
  "Gasto fijo",
  "Gasto variable",
  "Compra de mercadería",
  "Insumos",
  "Servicios",
  "Impuestos",
  "Alquiler",
  "Sueldos",
  "Transporte",
  "Otros",
];

const esCategoriaBase = (categoria) =>
  categoriasBase.some(
    (cat) =>
      cat.toLowerCase() === String(categoria || "").trim().toLowerCase()
  );

const combinarCategorias = (personalizadas = []) => {
  const resultado = [];

  [...categoriasBase, ...personalizadas].forEach((categoria) => {
    const nombre = String(categoria || "").trim();
    if (!nombre) return;

    const existe = resultado.some(
      (actual) => actual.toLowerCase() === nombre.toLowerCase()
    );

    if (!existe) {
      resultado.push(nombre);
    }
  });

  return resultado;
};

const itemVacio = () => ({
  descripcion: "",
  cantidad: 1,
  precioUnitario: 0,
});

const pagoVacio = () => ({
  monto: 0,
  medioPago: "efectivo",
});

const gastoInicial = {
  fecha: "",
  categoria: "",
  proveedor: "",
    proveedorId: "",
    proveedorNombre: "",
  comprobanteNumero: "",
  comprobantes: [],
  observaciones: "",
  items: [itemVacio()],
  pagos: [pagoVacio()],
};

export default function GastosPage({ perfil }) {

const puedeCrearGastos = puedeHacer(perfil, "gastos", "crear");
const puedeEditarGastos = puedeHacer(perfil, "gastos", "editar");
const puedeAnularGastos = puedeHacer(perfil, "gastos", "anular");
const puedeVerDetalleGastos = puedeHacer(perfil, "gastos", "verDetalle");

const puedeAbrirDetalleGastos =
  puedeVerDetalleGastos || puedeEditarGastos;

  const [gastos, setGastos] = useState([]);
  const [ultimoDoc, setUltimoDoc] = useState(null);
const [hayMas, setHayMas] = useState(true);
const [loading, setLoading] = useState(false);
const listenerInicializadoRef = useRef(false);
const versionListadoRef = useRef(0);
const [guardando, setGuardando] = useState(false);
  const [categorias, setCategorias] = useState(categoriasBase);
  const [proveedores, setProveedores] = useState([]);
const [proveedorDropdownAbierto, setProveedorDropdownAbierto] = useState(false);

  const [modalAbierto, setModalAbierto] = useState(false);
  const [gastoEditando, setGastoEditando] = useState(null);
  const [modalSoloLectura, setModalSoloLectura] = useState(false);
  const [form, setForm] = useState(gastoInicial);

  const [busqueda, setBusqueda] = useState("");
  const [filtroCategoria, setFiltroCategoria] = useState("");
  const [fechaDesde, setFechaDesde] = useState("");
  const [filtroSaldo, setFiltroSaldo] = useState("");
  const [mostrarFiltrosMobile, setMostrarFiltrosMobile] = useState(false);
  const [fechaHasta, setFechaHasta] = useState("");
  const limpiarFiltros = () => {
    setBusqueda("");
    setFiltroCategoria("");
    setFiltroSaldo("");
    setFechaDesde("");
    setFechaHasta("");
  };

  const [mostrarNuevaCategoria, setMostrarNuevaCategoria] = useState(false);
  const [nuevaCategoria, setNuevaCategoria] = useState("");
  const [categoriaDropdownAbierto, setCategoriaDropdownAbierto] = useState(false);
  const [editandoCategoria, setEditandoCategoria] = useState("");
  const [nombreCategoriaEditando, setNombreCategoriaEditando] = useState("");
  const [gastoMobileAbiertoId, setGastoMobileAbiertoId] = useState(null);



  const categoriaDropdownRef = useRef(null);

  useEffect(() => {
  if (!perfil?.clienteId) return;

  let cancelado = false;

  const cargarCategoriasGastos = async () => {
    try {
      const refCliente = doc(db, "clientes-saas", perfil.clienteId);
      const snap = await getDoc(refCliente);

      if (!snap.exists() || cancelado) return;

      const data = snap.data();

      const personalizadas = Array.isArray(data.categoriasGastos)
        ? data.categoriasGastos
        : [];

      setCategorias(combinarCategorias(personalizadas));
    } catch (error) {
      console.error("Error cargando categorías de gastos:", error);

      if (!cancelado) {
        setCategorias(categoriasBase);
      }
    }
  };

  cargarCategoriasGastos();

  return () => {
    cancelado = true;
  };
}, [perfil?.clienteId]);

const persistirCategoriasGastos = async (lista) => {
  if (!perfil?.clienteId) {
    throw new Error("No se encontró clienteId.");
  }

  const personalizadas = lista
    .map((categoria) => String(categoria || "").trim())
    .filter(Boolean)
    .filter((categoria) => !esCategoriaBase(categoria));

  const sinDuplicados = personalizadas.filter(
    (categoria, index, array) =>
      array.findIndex(
        (otra) => otra.toLowerCase() === categoria.toLowerCase()
      ) === index
  );

  const refCliente = doc(db, "clientes-saas", perfil.clienteId);

  await updateDoc(refCliente, {
    categoriasGastos: sinDuplicados,
  });
};

  useEffect(() => {
    const manejarClickAfuera = (event) => {
      if (
        categoriaDropdownRef.current &&
        !categoriaDropdownRef.current.contains(event.target)
      ) {
        setCategoriaDropdownAbierto(false);
        setMostrarNuevaCategoria(false);
        setEditandoCategoria("");
        setNombreCategoriaEditando("");
      }
    };

    document.addEventListener("mousedown", manejarClickAfuera);

    return () => {
      document.removeEventListener("mousedown", manejarClickAfuera);
    };
  }, []);

  const cargarGastos = async () => {
  try {
    setLoading(true);

    const res = await obtenerGastosPaginados({
      perfil,
      pageSize: 50,
      categoria: filtroCategoria,
      fechaDesde,
      fechaHasta,
      textoBusqueda: busqueda,
      filtroSaldo,
    });

    setGastos(res.gastos);
    setUltimoDoc(res.ultimoDoc);
    setHayMas(res.hayMas);
  } catch (error) {
    console.error("Error cargando gastos:", error);
    setGastos([]);
  } finally {
    setLoading(false);
  }
};

    const cargarMasGastos = async () => {
    try {
        if (!ultimoDoc || !hayMas) return;
        const versionListado = versionListadoRef.current;

        const res = await obtenerGastosPaginados({
        perfil,
        ultimoDoc,
        pageSize: 50,
        categoria: filtroCategoria,
        fechaDesde,
        fechaHasta,
        textoBusqueda: busqueda,
        filtroSaldo,
        });

        if (versionListado !== versionListadoRef.current) return;
        setGastos((actuales) =>
          fusionarDocumentosPaginados({
            actuales,
            entrantes: res.gastos,
            camposOrden: ["fecha", "createdAt"],
          })
        );
        setUltimoDoc(res.ultimoDoc);
        setHayMas(res.hayMas);
    } catch (error) {
        console.error("Error cargando más gastos:", error);
    }
    };

useEffect(() => {
  if (!perfil?.clienteId) return;

  listenerInicializadoRef.current = false;
  versionListadoRef.current += 1;
  setLoading(true);

  if (busqueda.trim() || filtroSaldo) {
    let cancelado = false;
    const timer = setTimeout(async () => {
      try {
        const res = await obtenerGastosPaginados({
          perfil,
          pageSize: 50,
          categoria: filtroCategoria,
          fechaDesde,
          fechaHasta,
          textoBusqueda: busqueda,
          filtroSaldo,
        });
        if (cancelado) return;
        setGastos(res.gastos);
        setUltimoDoc(res.ultimoDoc);
        setHayMas(res.hayMas);
      } catch (error) {
        if (!cancelado) {
          console.error("Error buscando gastos globalmente:", error);
          setGastos([]);
        }
      } finally {
        if (!cancelado) setLoading(false);
      }
    }, 350);

    return () => {
      cancelado = true;
      clearTimeout(timer);
    };
  }

  const unsubscribe = escucharGastosRecientes({
    perfil,
    pageSize: 50,
    categoria: filtroCategoria,
    fechaDesde,
    fechaHasta,
    onData: (res) => {
      if (!listenerInicializadoRef.current) {
        setGastos(res.gastos);
        setUltimoDoc(res.ultimoDoc);
        setHayMas(res.hayMas);
        listenerInicializadoRef.current = true;
      } else {
        setGastos((actuales) =>
          fusionarDocumentosPaginados({
            actuales,
            entrantes: res.gastos,
            camposOrden: ["fecha", "createdAt"],
          })
        );
      }
      setLoading(false);
    },
    onError: (error) => {
      console.error("Error escuchando gastos:", error);
      if (!listenerInicializadoRef.current) setGastos([]);
      setLoading(false);
    },
  });

  return () => unsubscribe();
}, [perfil, perfil?.clienteId, filtroCategoria, fechaDesde, fechaHasta, busqueda, filtroSaldo]);

useEffect(() => {
  if (!perfil?.clienteId) return;

  const unsub = escucharProveedores({
    perfil,
    onData: (lista) => {
      setProveedores(lista.filter((p) => p.activo !== false));
    },
    onError: console.error,
  });

  return () => unsub();
}, [perfil?.clienteId]);

  const abrirNuevoGasto = () => {
    if (!puedeCrearGastos) return;
    setGastoEditando(null);
    setModalSoloLectura(false);
    setForm({
      ...gastoInicial,
      fecha: fechaHoyNegocio(perfil),
      items: [itemVacio()],
      pagos: [pagoVacio()],
    });
    setModalAbierto(true);
  };

  const cerrarModal = () => {
    setModalAbierto(false);
    setGastoEditando(null);
    setForm({
      ...gastoInicial,
      fecha: fechaHoyNegocio(perfil),
      items: [itemVacio()],
      pagos: [pagoVacio()],
    });
    setMostrarNuevaCategoria(false);
    setNuevaCategoria("");
    setCategoriaDropdownAbierto(false);
  };

  const actualizarCampo = (campo, valor) => {
    setForm((prev) => ({
      ...prev,
      [campo]: valor,
    }));
  };

  const actualizarItem = (index, campo, valor) => {
    setForm((prev) => ({
      ...prev,
      items: prev.items.map((item, i) =>
        i === index ? { ...item, [campo]: valor } : item
      ),
    }));
  };

  const agregarItem = () => {
    setForm((prev) => ({
      ...prev,
      items: [...prev.items, itemVacio()],
    }));
  };

  const eliminarItem = (index) => {
    if (form.items.length === 1) return;

    setForm((prev) => ({
      ...prev,
      items: prev.items.filter((_, i) => i !== index),
    }));
  };

  const actualizarPago = (index, campo, valor) => {
    setForm((prev) => ({
        ...prev,
        pagos: prev.pagos.map((pago, i) =>
        i === index ? { ...pago, [campo]: valor } : pago
        ),
    }));
    };

    const agregarPago = () => {
    setForm((prev) => ({
        ...prev,
        pagos: [...(prev.pagos || []), pagoVacio()],
    }));
    };

    const eliminarPago = (index) => {
    if ((form.pagos || []).length === 1) return;

    setForm((prev) => ({
        ...prev,
        pagos: prev.pagos.filter((_, i) => i !== index),
    }));
    };

const agregarComprobantes = (archivos) => {
  const lista = Array.from(archivos || []);

  if (!lista.length) return;

  const LIMITE = 2 * 1024 * 1024; // 2 MB

  const archivosValidos = [];

  for (const archivo of lista) {
    if (archivo.size > LIMITE) {
      alert(
        `"${archivo.name}" supera el tamaño máximo permitido de 2 MB.`
      );
      continue;
    }

    archivosValidos.push({
      id: crypto.randomUUID(),
      nombre: archivo.name,
      tipo: archivo.type,
      size: archivo.size,
      archivo,
      urlTemporal: URL.createObjectURL(archivo),
    });
  }

  if (!archivosValidos.length) return;

  setForm((prev) => ({
    ...prev,
    comprobantes: [
      ...(prev.comprobantes || []),
      ...archivosValidos,
    ],
  }));
};

        const eliminarComprobante = (comprobanteId) => {
        setForm((prev) => ({
            ...prev,
            comprobantes: (prev.comprobantes || []).filter(
            (c) => c.id !== comprobanteId
            ),
        }));
        };

const verComprobante = (comprobante) => {
  if (comprobante?.urlTemporal) {
    window.open(comprobante.urlTemporal, "_blank");
    return;
  }

  if (comprobante?.url) {
    window.open(comprobante.url, "_blank");
  }
};

  const itemsNormalizados = useMemo(() => {
    return (form.items || []).map((item) => {
      const cantidad = Number(item.cantidad || 0);
      const precioUnitario = Number(item.precioUnitario || 0);

      return {
        ...item,
        cantidad,
        precioUnitario,
        subtotal: cantidad * precioUnitario,
      };
    });
  }, [form.items]);

  const totalModal = useMemo(() => {
    return itemsNormalizados.reduce(
      (acc, item) => acc + Number(item.subtotal || 0),
      0
    );
  }, [itemsNormalizados]);

  const totalPagadoModal = useMemo(() => {
    return (form.pagos || []).reduce(
        (acc, pago) => acc + Number(pago.monto || 0),
        0
    );
    }, [form.pagos]);

    const saldoModal = useMemo(() => {
    const saldo = totalModal - totalPagadoModal;
    return saldo < 0 ? 0 : saldo;
    }, [totalModal, totalPagadoModal]);

  const seleccionarCategoria = (cat) => {
    actualizarCampo("categoria", cat);
    setMostrarNuevaCategoria(false);
    setNuevaCategoria("");
    setCategoriaDropdownAbierto(false);
  };

 const guardarNuevaCategoriaDropdown = async () => {
  const nombre = nuevaCategoria.trim();
  if (!nombre) return;

  const existente = categorias.find(
    (cat) => cat.toLowerCase() === nombre.toLowerCase()
  );

  if (existente) {
    seleccionarCategoria(existente);
    return;
  }

  const nuevasCategorias = [nombre, ...categorias];

  try {
    await persistirCategoriasGastos(nuevasCategorias);

    setCategorias(nuevasCategorias);
    seleccionarCategoria(nombre);
  } catch (error) {
    console.error("Error guardando categoría de gasto:", error);
    alert("No se pudo guardar la categoría.");
  }
};

const guardarEdicionCategoria = async (categoriaOriginal) => {
  const nuevoNombre = nombreCategoriaEditando.trim();
  if (!nuevoNombre) return;

  if (esCategoriaBase(categoriaOriginal)) {
    alert("Las categorías predeterminadas no se pueden renombrar.");
    return;
  }

  const duplicada = categorias.some(
    (cat) =>
      cat !== categoriaOriginal &&
      cat.toLowerCase() === nuevoNombre.toLowerCase()
  );

  if (duplicada) {
    alert("Ya existe una categoría con ese nombre.");
    return;
  }

  const nuevasCategorias = categorias.map((cat) =>
    cat === categoriaOriginal ? nuevoNombre : cat
  );

  try {
    await persistirCategoriasGastos(nuevasCategorias);

    setCategorias(nuevasCategorias);

    if (form.categoria === categoriaOriginal) {
      actualizarCampo("categoria", nuevoNombre);
    }

    if (filtroCategoria === categoriaOriginal) {
      setFiltroCategoria(nuevoNombre);
    }

    setEditandoCategoria("");
    setNombreCategoriaEditando("");
  } catch (error) {
    console.error("Error renombrando categoría:", error);
    alert("No se pudo renombrar la categoría.");
  }
};

const eliminarCategoria = async (categoria) => {
  if (esCategoriaBase(categoria)) {
    alert("Las categorías predeterminadas no se pueden eliminar.");
    return;
  }

  const confirmar = window.confirm(
    `¿Eliminar la categoría "${categoria}"?`
  );

  if (!confirmar) return;

  const nuevasCategorias = categorias.filter(
    (cat) => cat !== categoria
  );

  try {
    await persistirCategoriasGastos(nuevasCategorias);

    setCategorias(nuevasCategorias);

    if (form.categoria === categoria) {
      actualizarCampo("categoria", "");
    }

    if (filtroCategoria === categoria) {
      setFiltroCategoria("");
    }
  } catch (error) {
    console.error("Error eliminando categoría:", error);
    alert("No se pudo eliminar la categoría.");
  }
};

  const guardarGasto = async () => {
    if (!form.fecha) {
      alert("Seleccioná una fecha.");
      return;
    }

    if (!form.categoria) {
      alert("Seleccioná una categoría.");
      return;
    }

    const itemsValidos = itemsNormalizados.filter(
      (item) =>
        item.descripcion.trim() &&
        Number(item.cantidad) > 0 &&
        Number(item.precioUnitario) >= 0
    );

    if (!itemsValidos.length) {
      alert("Agregá al menos un ítem válido.");
      return;
    }

    if (totalModal <= 0) {
      alert("El total del gasto debe ser mayor a 0.");
      return;
    }

    const descripcionResumen =
      itemsValidos.length === 1
        ? itemsValidos[0].descripcion
        : `${itemsValidos.length} ítems`;

    const gastoNormalizado = {
      fecha: form.fecha,
      categoria: form.categoria,
      proveedor: form.proveedorNombre || form.proveedor || "",
        proveedorId: form.proveedorId || "",
        proveedorNombre: form.proveedorNombre || form.proveedor || "",
      comprobanteNumero: form.comprobanteNumero || "",
      comprobantes: form.comprobantes || [],
      observaciones: form.observaciones || "",
      medioPago: form.pagos?.[0]?.medioPago || "",
      descripcion: descripcionResumen,
        items: itemsValidos,
        pagos: (form.pagos || []).map((pago) => ({
        monto: Number(pago.monto || 0),
        medioPago: pago.medioPago || "efectivo",
        })),
        total: totalModal,
        totalPagado: totalPagadoModal,
        saldo: saldoModal,
        monto: totalModal,
      activo: true,
      creadoPor: perfil?.uid || perfil?.firebaseUid || "",
      creadoPorNombre: perfil?.nombre || perfil?.email || "",
      clienteId: perfil?.clienteId || "",
    };

    try {
    setGuardando(true);

    if (gastoEditando?.firebaseId) {
        await actualizarGasto({
        perfil,
        gastoId: gastoEditando.firebaseId,
        gasto: gastoNormalizado,
        });
    } else {
        await crearGasto({
        perfil,
        gasto: gastoNormalizado,
        });
    }

    cerrarModal();
    await cargarGastos();
    } catch (error) {
    console.error("Error guardando gasto:", error);
    alert(error.message || "No se pudo guardar el gasto.");
    } finally {
    setGuardando(false);
    }

    
  };

  const abrirDetalleGasto = (gasto) => {
  if (!puedeAbrirDetalleGastos) return;

  setGastoEditando(gasto);
  setModalSoloLectura(!puedeEditarGastos);

  setForm({
    fecha: gasto.fecha || "",
    categoria: gasto.categoria || "",
    proveedor: gasto.proveedor || "",
    proveedorId: gasto.proveedorId || "",
    proveedorNombre: gasto.proveedorNombre || gasto.proveedor || "",
    comprobanteNumero: gasto.comprobanteNumero || "",
    comprobantes: gasto.comprobantes || [],
    observaciones: gasto.observaciones || "",

    items: gasto.items?.length
      ? gasto.items.map((item) => ({
          descripcion: item.descripcion || "",
          cantidad: item.cantidad || 1,
          precioUnitario: item.precioUnitario || 0,
        }))
      : [
          {
            descripcion: gasto.descripcion || "",
            cantidad: 1,
            precioUnitario: gasto.monto || 0,
          },
        ],

    pagos: gasto.pagos?.length
      ? gasto.pagos.map((pago) => ({
          monto: pago.monto || 0,
          medioPago: pago.medioPago || "efectivo",
        }))
      : [
          {
            monto: gasto.total || gasto.monto || 0,
            medioPago: gasto.medioPago || "efectivo",
          },
        ],
  });

  setModalAbierto(true);
};

  const editarGasto = (gasto) => {
    if (!puedeEditarGastos) return;
    setModalSoloLectura(false);
    
    setGastoEditando(gasto);
    setForm({
      fecha: gasto.fecha || "",
      categoria: gasto.categoria || "",
      proveedor: gasto.proveedor || "",
      proveedorId: gasto.proveedorId || "",
      proveedorNombre: gasto.proveedorNombre || gasto.proveedor || "",
      comprobanteNumero: gasto.comprobanteNumero || "",
      comprobantes: gasto.comprobantes || [],
      observaciones: gasto.observaciones || "",
      
      items: gasto.items?.length
        ? gasto.items.map((item) => ({
            descripcion: item.descripcion || "",
            cantidad: item.cantidad || 1,
            precioUnitario: item.precioUnitario || 0,
          }))
        : [
            {
              descripcion: gasto.descripcion || "",
              cantidad: 1,
              precioUnitario: gasto.monto || 0,
            },
          ],
      pagos: gasto.pagos?.length
        ? gasto.pagos.map((pago) => ({
            monto: pago.monto || 0,
            medioPago: pago.medioPago || "efectivo",
            }))
        : [
            {
                monto: gasto.total || gasto.monto || 0,
                medioPago: gasto.medioPago || "efectivo",
            },
            ],    
    });
    setModalAbierto(true);
  };



const anularGastoLocal = async (gasto) => {
  const confirmar = window.confirm("¿Querés anular este gasto?");
  if (!confirmar) return;

  try {
    await anularGasto({
      perfil,
      gastoId: gasto.firebaseId,
      motivo: "",
    });

    await cargarGastos();
  } catch (error) {
    console.error("Error anulando gasto:", error);
    alert("No se pudo anular el gasto.");
  }
};

const duplicarGastoLocal = async (gasto) => {
  try {
    await duplicarGasto({
      perfil,
      gasto,
    });

    await cargarGastos();
  } catch (error) {
    console.error("Error duplicando gasto:", error);
    alert("No se pudo duplicar el gasto.");
  }
};

  const gastosFiltrados = useMemo(() => {
    const texto = busqueda.trim().toLowerCase();

    return gastos.filter((g) => {
      const coincideTexto =
        !texto ||
        String(g.descripcion || "").toLowerCase().includes(texto) ||
        String(g.proveedor || "").toLowerCase().includes(texto) ||
        String(g.medioPago || "").toLowerCase().includes(texto) ||
        (g.items || []).some((item) =>
          String(item.descripcion || "").toLowerCase().includes(texto)
        );

      const coincideCategoria =
        !filtroCategoria || g.categoria === filtroCategoria;

      const coincideDesde = !fechaDesde || g.fecha >= fechaDesde;
        const coincideHasta = !fechaHasta || g.fecha <= fechaHasta;

        const total = Number(g.total || g.monto || 0);
        const totalPagado = Number(g.totalPagado || 0);
        const saldo = Number(g.saldo || 0);
        const saldoAFavor = totalPagado > total ? totalPagado - total : 0;

        const coincideSaldo =
        !filtroSaldo ||
        (filtroSaldo === "pendiente" && saldo > 0) ||
        (filtroSaldo === "a_favor" && saldoAFavor > 0) ||
        (filtroSaldo === "cero" && saldo === 0 && saldoAFavor === 0);

        return (
        coincideTexto &&
        coincideCategoria &&
        coincideDesde &&
        coincideHasta &&
        coincideSaldo
        );
    });
  }, [gastos, busqueda, filtroCategoria, filtroSaldo, fechaDesde, fechaHasta]);

  const totalGastos = useMemo(() => {
    return gastosFiltrados
      .filter((g) => g.activo !== false)
      .reduce((acc, g) => acc + Number(g.total || g.monto || 0), 0);
  }, [gastosFiltrados]);

  const formatearMonto = (valor) => {
    return Number(valor || 0).toLocaleString("es-AR", {
      style: "currency",
      currency: perfil?.moneda || "ARS",
      maximumFractionDigits: 0,
    });
  };

  return (
    <div className="clientes-lista gastos-page">
      <div className="encabezado-lista">
        <div>
          <h1>Gastos</h1>
          
        </div>

            {puedeCrearGastos && (
            <button className="btn btn-primary" onClick={abrirNuevoGasto}>
                + Nuevo gasto
            </button>
            )}
      </div>

      {!modalAbierto && (
        <div className="container-secundaria">
        <h3 style={{ marginTop: 0 }}>Listado de gastos</h3>

        <button
        type="button"
        className="gastos-filtros-toggle"
        onClick={() => setMostrarFiltrosMobile((prev) => !prev)}
        >
        {mostrarFiltrosMobile ? "Ocultar filtros" : "Mostrar filtros"}
        </button>

        <div
          className={`gastos-filtros-grid ${
            mostrarFiltrosMobile ? "abierto" : ""
            }`}
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
            gap: 12,
            alignItems: "end",
          }}
        >
          <div>
            <label>Buscar</label>
            <input
              value={busqueda}
              onChange={(e) => setBusqueda(e.target.value)}
              placeholder="Descripción, proveedor..."
            />
          </div>

          <div>
            <label>Categoría</label>
            <select
              value={filtroCategoria}
              onChange={(e) => setFiltroCategoria(e.target.value)}
            >
              <option value="">Todas</option>
              {categorias.map((cat) => (
                <option key={cat} value={cat}>
                  {cat}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label>Saldo</label>
            <select
                value={filtroSaldo}
                onChange={(e) => setFiltroSaldo(e.target.value)}
            >
                <option value="">Todos</option>
                <option value="pendiente">Pendientes</option>
                <option value="a_favor">A favor</option>
                <option value="cero">$0</option>
            </select>
          </div>

          <div>
            <label>Desde</label>
            <input
              type="date"
              value={fechaDesde}
              onChange={(e) => setFechaDesde(e.target.value)}
            />
          </div>

          <div>
            <label>Hasta</label>
            <input
              type="date"
              value={fechaHasta}
              onChange={(e) => setFechaHasta(e.target.value)}
            />
          </div>
            {(busqueda ||
            filtroCategoria ||
            filtroSaldo ||
            fechaDesde ||
            fechaHasta) && (
            <div
            style={{
                display: "flex",
                alignItems: "center",
            }}
            >
                <button
                type="button"
                className="btn btn-secundario"
                onClick={limpiarFiltros}
                 style={{
                    transform: "translateY(-12px)",
                 }}
                >
                Limpiar
                </button>
            </div>
            )}
        </div>

 

        <div style={{ width: "100%", overflowX: "auto", marginTop: 16 }}>
          <table style={{ minWidth: 760 }}>
            <thead>
              <tr>
                <th>N°</th>
                <th>Fecha</th>
                <th>Categoría</th>
                
                <th>Proveedor</th>
                <th>Medio</th>
                <th>Total</th>
                <th>Saldo</th>
                <th>Estado</th>
                <th>Acciones</th>
              </tr>
            </thead>

            <tbody>
              {gastosFiltrados.map((g) => (
                <tr
                    key={g.firebaseId}
                    className={g.activo === false ? "gasto-anulado" : ""}
                   onClick={() => {
                    if (puedeEditarGastos) {
                        editarGasto(g);
                        return;
                    }

                   if (puedeAbrirDetalleGastos) {
                    abrirDetalleGasto(g);
                   }
                    }}
                style={{
                    opacity: g.activo === false ? 0.55 : 1,
                    cursor: "pointer",
                }}
                >
                  <td>{g.numeroGasto ? `#${g.numeroGasto}` : "-"}</td>  
                  <td>{g.fecha}</td>
                  <td>
                    {g.categoria}

                    {g.activo === false && (
                        <span className="badge-anulado">
                        ANULADO
                        </span>
                    )}
                    </td>
                  
                  <td>{g.proveedorNombre || g.proveedor || "-"}</td>
                  <td>{g.pagos?.[0]?.medioPago || g.medioPago || "-"}</td>
                  <td>{formatearMonto(g.total || g.monto)}</td>

                    <td>
                    {(() => {
                        const saldo = Number(g.saldo || 0);
                        const totalPagado = Number(g.totalPagado || 0);
                        const total = Number(g.total || g.monto || 0);
                        const saldoAFavor = totalPagado > total ? totalPagado - total : 0;

                        let texto = "$0";
                        let bg = "#dcfce7";
                        let color = "#166534";

                        if (saldo > 0) {
                        texto = `Debe ${formatearMonto(saldo)}`;
                        bg = "#fee2e2";
                        color = "#991b1b";
                        }

                        if (saldoAFavor > 0) {
                        texto = `A favor ${formatearMonto(saldoAFavor)}`;
                        bg = "#dbeafe";
                        color = "#1e40af";
                        }

                        return (
                        <span
                            style={{
                            display: "inline-block",
                            padding: "4px 8px",
                            borderRadius: 999,
                            background: bg,
                            color,
                            fontWeight: 700,
                            fontSize: 12,
                            whiteSpace: "nowrap",
                            }}
                        >
                            {texto}
                        </span>
                        );
                    })()}
                    </td>

                    <td>
                    {g.activo === false ? (
                        <span className="badge-anulado">
                        ANULADO
                        </span>
                    ) : (
                        "Activo"
                    )}
                    </td>
                    <td onClick={(e) => e.stopPropagation()}>
                        <ActionMenu
                       onVer={
                        puedeAbrirDetalleGastos
                            ? () => abrirDetalleGasto(g)
                            : undefined
                        }
                        onEditar={
                            puedeEditarGastos
                            ? () => editarGasto(g)
                            : undefined
                        }
                        onEliminar={
                            puedeAnularGastos && g.activo !== false
                            ? () => anularGastoLocal(g)
                            : undefined
                        }
                        />
                    </td>
                </tr>
              ))}

              {gastosFiltrados.length === 0 && (
                <tr>
                  <td colSpan="9" style={{ textAlign: "center", padding: 18 }}>
                    Todavía no hay gastos cargados.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          {hayMas && (
            <div style={{ textAlign: "center", marginTop: 16 }}>
                <button className="btn btn-secondary" onClick={cargarMasGastos}>
                Cargar más
                </button>
            </div>
           )}
        </div>
        <div className="gastos-mobile-list">
            {gastosFiltrados.map((g) => {
                const abierto = gastoMobileAbiertoId === g.firebaseId;

                return (
                <div
                    key={g.firebaseId}
                    className={`gasto-mobile-card ${
                        g.activo === false ? "gasto-mobile-anulado" : ""
                    }`}
                >
                    <div
                    className="gasto-mobile-header"
                    onClick={() =>
                        setGastoMobileAbiertoId((prev) =>
                        prev === g.firebaseId ? null : g.firebaseId
                        )
                    }
                    >
                    <div>
                        <strong className="gasto-mobile-numero">
                        #{g.numeroGasto || "-"}
                        </strong>
                        <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 6,
                            flexWrap: "wrap",
                        }}
                        >
                        <span>{g.categoria || "-"}</span>

                        {g.activo === false && (
                            <span className="badge-anulado">
                            ANULADO
                            </span>
                        )}
                        </div>
                    </div>

                    <div>
                        <strong>{formatearMonto(g.total || g.monto)}</strong>
                        <span className="gasto-mobile-arrow">
                        {abierto ? "⌃" : "⌄"}
                        </span>
                    </div>
                    </div>

                    {abierto && (
                    <div className="gasto-mobile-body">
                        <p><b>Fecha:</b> {g.fecha}</p>
                        <p><b>Proveedor:</b> {g.proveedorNombre || g.proveedor || "-"}</p>
                        <p><b>Medio:</b> {g.pagos?.[0]?.medioPago || g.medioPago || "-"}</p>
                        <p><b>Estado:</b> {g.activo === false ? "Anulado" : "Activo"}</p>

                        {(puedeAbrirDetalleGastos || puedeEditarGastos || puedeAnularGastos) && (
                        <div className="gasto-mobile-actions">
                            {puedeAbrirDetalleGastos && (
                            <button
                            className="gasto-mobile-btn-primary"
                            onClick={() => abrirDetalleGasto(g)}
                            >
                            Ver
                            </button>
                            )}

                            {puedeEditarGastos && (
                            <button
                            className="gasto-mobile-btn-secondary"
                            onClick={() => editarGasto(g)}
                            >
                            Editar
                            </button>
                            )}

                            {puedeAnularGastos && g.activo !== false && (
                            <button
                            className="gasto-mobile-btn-secondary"
                            onClick={() => anularGastoLocal(g)}
                            >
                            Anular
                            </button>
                            )}
                        </div>
                        )}
                    </div>
                    )}
                </div>
                );
            })}
            </div>
      </div>

      )}

      {modalAbierto && (
        <div className="modal-overlay">
          <div className="modal-content" style={{ maxWidth: 1000 }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: 12,
                alignItems: "center",
                marginBottom: 16,
              }}
            >
              <div>
                <h2 style={{ margin: 0 }}>
                  {modalSoloLectura
                    ? "Detalle del gasto"
                    : gastoEditando
                    ? "Editar gasto"
                    : "Nuevo gasto"}
                </h2>
                <p style={{ margin: "6px 0 0", color: "#666" }}>
                  {modalSoloLectura
                    ? "Vista de solo lectura. No tenés permisos para modificar este gasto."
                    : "Cargá uno o varios ítems del gasto."}
                </p>
              </div>

              <button className="btn btn-secondary" onClick={cerrarModal}>
                Cerrar
              </button>
            </div>

            <div
                style={{
                display: "grid",
                gridTemplateColumns: "160px minmax(240px, 1fr) minmax(220px, 1fr) minmax(220px, 1fr)",
                gap: 12,
                alignItems: "end",
                }}
            >
              <div>
                <label>Fecha</label>
                <input
                  type="date"
                  value={form.fecha}
                  onChange={(e) => actualizarCampo("fecha", e.target.value)}
                  disabled={modalSoloLectura}
                />
              </div>

                <div
                ref={categoriaDropdownRef}
                style={{
                    position: "relative",
                    width: "100%",
                }}
                >
                <label>Categoría</label>

                <div
                  onClick={() => {
                    if (modalSoloLectura) return;
                    setCategoriaDropdownAbierto((prev) => !prev);
                    }}
                    style={{
                    width: "100%",
                    height: 38,
                    padding: "0 12px",
                    border: "1px solid #d3d9de",
                    borderRadius: 6,
                    background: "#fff",
                    cursor: modalSoloLectura ? "not-allowed" : "pointer",
                    opacity: modalSoloLectura ? 0.75 : 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 10,
                    marginBottom: 14,
                    }}
                >
                  <span style={{ color: form.categoria ? "#1a1a1a" : "#777" }}>
                    {form.categoria || "Seleccionar"}
                  </span>
                  <span style={{ color: "#0096d1" }}>▾</span>
                </div>

                {categoriaDropdownAbierto && (
                  <div
                    style={{
                      position: "absolute",
                      top: "calc(100% + 6px)",
                      left: 0,
                      right: 0,
                      minWidth: 320,
                      background: "#fff",
                      border: "1px solid #d3d9de",
                      borderRadius: 12,
                      boxShadow: "0 10px 24px rgba(0,0,0,0.14)",
                      zIndex: 3000,
                      maxHeight: 320,
                      overflowY: "auto",
                      padding: 8,
                    }}
                  >
                    <div
                      onClick={(e) => {
                        e.stopPropagation();
                        setMostrarNuevaCategoria(true);
                        setNuevaCategoria("");
                      }}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 12,
                        padding: "12px 14px",
                        borderRadius: 10,
                        cursor: "pointer",
                        color: "#0096d1",
                        fontWeight: 700,
                        background: mostrarNuevaCategoria ? "#eaf7ff" : "transparent",
                        marginBottom: 4,
                      }}
                    >
                      <FaPlus size={14} />
                      Nueva categoría
                    </div>

                    {mostrarNuevaCategoria && (
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "1fr 30px",
                          gap: 8,
                          alignItems: "center",
                          padding: "6px 8px 10px",
                        }}
                      >
                        <input
                          autoFocus
                          value={nuevaCategoria}
                          onChange={(e) => setNuevaCategoria(e.target.value)}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                              guardarNuevaCategoriaDropdown();
                            }

                            if (e.key === "Escape") {
                              setMostrarNuevaCategoria(false);
                              setNuevaCategoria("");
                            }
                          }}
                          placeholder="Crear categoría"
                          style={{
                            marginBottom: 0,
                            borderColor: "#0096d1",
                            boxShadow: "0 0 0 2px rgba(0,150,209,0.12)",
                          }}
                        />

                        {nuevaCategoria.trim() && (
                          <button
                            type="button"
                            onClick={guardarNuevaCategoriaDropdown}
                            style={{
                              padding: 0,
                              margin: 0,
                              width: 28,
                              height: 28,
                              borderRadius: "50%",
                              background: "transparent",
                              color: "#0096d1",
                            }}
                            title="Confirmar categoría"
                          >
                            <FaCheck size={14} />
                          </button>
                        )}
                      </div>
                    )}

                    {categorias.map((cat) => (
                      <div
                        key={cat}
                        onClick={() => seleccionarCategoria(cat)}
                        style={{
                          display: "grid",
                          gridTemplateColumns: "minmax(0, 1fr) 34px 34px",
                          gap: 10,
                          alignItems: "center",
                          padding: "12px 14px",
                          borderRadius: 10,
                          cursor: "pointer",
                          background: form.categoria === cat ? "#eaf7ff" : "transparent",
                          marginBottom: 2,
                        }}
                      >
                        {editandoCategoria === cat ? (
                          <input
                            autoFocus
                            value={nombreCategoriaEditando}
                            onClick={(e) => e.stopPropagation()}
                            onChange={(e) =>
                              setNombreCategoriaEditando(e.target.value)
                            }
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault();
                                guardarEdicionCategoria(cat);
                              }

                              if (e.key === "Escape") {
                                setEditandoCategoria("");
                                setNombreCategoriaEditando("");
                              }
                            }}
                            style={{ marginBottom: 0 }}
                          />
                        ) : (
                          <span>{cat}</span>
                        )}

                    {!esCategoriaBase(cat) && (
                      <>
                        <button
                          type="button"
                          onClick={(e) => {
                            e.stopPropagation();

                            if (editandoCategoria === cat) {
                              guardarEdicionCategoria(cat);
                            } else {
                              setEditandoCategoria(cat);
                              setNombreCategoriaEditando(cat);
                            }
                          }}
                          style={{
                            padding: 0,
                            margin: 0,
                            width: 28,
                            height: 28,
                            borderRadius: "50%",
                            background: "transparent",
                            color: "#0096d1",
                          }}
                          title="Editar categoría"
                        >
                          {editandoCategoria === cat ? (
                            <FaCheck size={14} />
                          ) : (
                            <FaEdit size={15} />
                          )}
                        </button>

                        <button
                          type="button"
                          onClick={(e) => {
                            e.stopPropagation();
                            eliminarCategoria(cat);
                          }}
                          style={{
                            padding: 0,
                            margin: 0,
                            width: 28,
                            height: 28,
                            borderRadius: "50%",
                            background: "transparent",
                            color: "#0096d1",
                          }}
                          title="Eliminar categoría"
                        >
                          <FaTrash size={14} />
                        </button>
                      </>
                    )}
                      </div>
                    ))}
                  </div>
                )}
              </div>

            <div>
            <label>Proveedor opcional</label>
            <select
                value={form.proveedorId || ""}
                onChange={(e) => {
                const proveedor = proveedores.find(
                    (p) => p.firebaseId === e.target.value
                );

                actualizarCampo("proveedorId", proveedor?.firebaseId || "");
                actualizarCampo("proveedorNombre", proveedor?.nombre || "");
                actualizarCampo("proveedor", proveedor?.nombre || "");
                }}
                disabled={modalSoloLectura}
            >
                <option value="">Sin proveedor</option>

                {proveedores.map((p) => (
                <option key={p.firebaseId} value={p.firebaseId}>
                    {p.nombre}
                </option>
                ))}
            </select>
            </div>

            <div className="gastos-comprobante-row">
            <label>N° comprobante / factura</label>

            <div className="gastos-comprobante-wrap">
                <input
                value={form.comprobanteNumero}
                onChange={(e) =>
                    actualizarCampo("comprobanteNumero", e.target.value)
                }
                placeholder="Ej: Factura A 0001-00001234"
                disabled={modalSoloLectura}
                />

               <label
                    className="gastos-adjunto-btn"
                    title={
                        modalSoloLectura
                        ? "Solo lectura"
                        : "Adjuntar comprobante"
                    }
                    style={{
                        pointerEvents: modalSoloLectura ? "none" : "auto",
                        opacity: modalSoloLectura ? 0.5 : 1,
                    }}
                >
                <FaPaperclip size={15} />

                <input
                    type="file"
                    multiple
                    accept="image/*,.pdf"
                    style={{ display: "none" }}
                    onChange={(e) => {
                    agregarComprobantes(e.target.files);
                    e.target.value = "";
                    }}
                />
                </label>
            </div>

            {(form.comprobantes || []).length > 0 && (
                <div className="gastos-adjuntos-lista">
                {(form.comprobantes || []).map((comp) => (
                    <div key={comp.id} className="gastos-adjunto-chip">
                    <span className="gastos-adjunto-nombre" title={comp.nombre}>
                        {comp.nombre}
                    </span>

                    <button
                        type="button"
                        className="gastos-adjunto-icon-btn"
                        onClick={() => verComprobante(comp)}
                        title="Ver comprobante"
                    >
                        <FaEye size={12} />
                    </button>

                   {!modalSoloLectura && (
                    <button
                        type="button"
                        className="gastos-adjunto-icon-btn"
                        onClick={() => eliminarComprobante(comp.id)}
                        title="Quitar comprobante"
                    >
                        ×
                    </button>
                    )}
                    </div>
                ))}
                </div>
            )}
            </div>

               <div className="gastos-observaciones">
                    <label>Observaciones</label>
                    <textarea
                        value={form.observaciones}
                        onChange={(e) => actualizarCampo("observaciones", e.target.value)}
                        placeholder="Notas internas del gasto, aclaraciones o detalles adicionales..."
                        rows={3}
                        disabled={modalSoloLectura}
                    />
                </div>

             
            </div>

            <div style={{ marginTop: 16 }}>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <h3 style={{ marginTop: 0 }}>Ítems del gasto</h3>

                {!modalSoloLectura && (
                <button className="btn btn-primary" onClick={agregarItem}>
                    + Agregar ítem
                </button>
                )}
              </div>

              <div style={{ width: "100%", overflowX: "auto" }}>
                <table style={{ minWidth: 680 }}>
                  <thead>
                    <tr>
                      <th>Descripción</th>
                      <th>Cant.</th>
                      <th>Precio</th>
                      <th>Subtotal</th>
                      <th></th>
                    </tr>
                  </thead>

                  <tbody>
                    {itemsNormalizados.map((item, index) => (
                      <tr key={`item-${index}`}>
                        <td>
                          <input
                            value={item.descripcion}
                            onChange={(e) =>
                              actualizarItem(index, "descripcion", e.target.value)
                            }
                            placeholder="Ej: Tela, tinta, servicio..."
                            disabled={modalSoloLectura}
                          />
                        </td>

                        <td>
                          <input
                            type="number"
                            value={item.cantidad}
                            onChange={(e) =>
                              actualizarItem(index, "cantidad", e.target.value)
                            }
                            min="0"
                            disabled={modalSoloLectura}
                          />
                        </td>

                        <td>
                          <input
                            type="number"
                            value={item.precioUnitario}
                            onChange={(e) =>
                              actualizarItem(index, "precioUnitario", e.target.value)
                            }
                            min="0"
                            disabled={modalSoloLectura}
                          />
                        </td>

                        <td>{formatearMonto(item.subtotal)}</td>

                        <td>
                            {!modalSoloLectura && (
                            <button
                                className="btn"
                                onClick={() => eliminarItem(index)}
                                disabled={form.items.length === 1}
                            >
                                X
                            </button>
                            )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>


              <div
                style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginTop: 18,
                }}
                >
                <div
                    style={{
                    width: 340,
                    padding: 16,
                    borderRadius: 14,
                    background: "#f8fafc",
                    border: "1px solid #e5e7eb",
                    display: "grid",
                    gap: 10,
                    }}
                >
                    <h3 style={{ margin: 0 }}>Resumen</h3>

                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <span>Subtotal</span>
                    <strong>{formatearMonto(totalModal)}</strong>
                    </div>

                    <div
                    style={{
                        borderTop: "1px solid #e5e7eb",
                        paddingTop: 10,
                        display: "grid",
                        gap: 8,
                    }}
                    >
                    <strong>Pagos iniciales</strong>

                    {(form.pagos || []).map((pago, index) => (
                        <div
                        key={`${pago.medioPago}-${index}`}
                        style={{
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr 28px",
                            gap: 8,
                            alignItems: "center",
                        }}
                        >
                        <input
                            type="number"
                            value={pago.monto}
                            onChange={(e) =>
                            actualizarPago(index, "monto", e.target.value)
                            }
                            min="0"
                            placeholder="0"
                            style={{ marginBottom: 0 }}
                            disabled={modalSoloLectura}
                        />

                        <select
                            value={pago.medioPago}
                            onChange={(e) =>
                            actualizarPago(index, "medioPago", e.target.value)
                            }
                            style={{ marginBottom: 0 }}
                            disabled={modalSoloLectura}
                        >
                            <option value="efectivo">Efectivo</option>
                            <option value="efectivo_caja">Efectivo de caja</option>
                            <option value="transferencia">Transferencia</option>
                            <option value="debito">Débito</option>
                            <option value="credito">Crédito</option>
                            <option value="mercado_pago">Mercado Pago</option>
                            <option value="otro">Otro</option>
                        </select>

                        {!modalSoloLectura && (
                        <button
                            type="button"
                            onClick={() => eliminarPago(index)}
                            disabled={(form.pagos || []).length === 1}
                            style={{
                            padding: 0,
                            margin: 0,
                            width: 28,
                            height: 28,
                            borderRadius: "50%",
                            background: "transparent",
                            color: "#0096d1",
                            fontSize: 18,
                            }}
                        >
                            ×
                        </button>
                        )}
                        </div>
                    ))}

                    {!modalSoloLectura && (
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={agregarPago}
                        style={{
                        width: "100%",
                        margin: 0,
                        }}
                    >
                        + Agregar otro pago
                    </button>
                    )}
                    </div>

                    <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        borderTop: "1px solid #e5e7eb",
                        paddingTop: 10,
                    }}
                    >
                    <span>Total pagado</span>
                    <strong>{formatearMonto(totalPagadoModal)}</strong>
                    </div>

                    <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        fontWeight: 800,
                        fontSize: 16,
                    }}
                    >
                    <span>Saldo pendiente</span>
                    <span>{formatearMonto(saldoModal)}</span>
                    </div>
                </div>
                </div>
              </div>
            

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 10,
                marginTop: 20,
                flexWrap: "wrap",
              }}
            >
              <button className="btn btn-secondary" onClick={cerrarModal}>
                Cancelar
              </button>

               {!modalSoloLectura && (
                <button
                    className="btn btn-primary"
                    onClick={guardarGasto}
                    disabled={guardando}
                >
                    {guardando
                    ? "Guardando..."
                    : gastoEditando
                    ? "Guardar cambios"
                    : "Guardar gasto"}
                </button>
                )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

